import ViewCustomer from './ViewCustomer'
export default ViewCustomer
